import React, {
  useEffect,
  useState,
} from 'react';
import Spinner from '../../../../Spinner';
import {
  FieldFile,
  isRemoteFile,
} from '../../types';
import {
  getFilePreview,
} from '../utils';

const VideoPreview: React.FC<FieldFile> = (props) => {
  const [preview, setPreview] = useState<string>('');

  useEffect(() => {
    if (!isRemoteFile(props)) {
      const getPreview = async () => {
        const source = await getFilePreview(props.file);
        setPreview(source);
      };
      getPreview();
    }
  }, [
    props,
  ]);

  if (isRemoteFile(props)) {
    const {
      source,
    } = props;
    return (
      <video
        style={{
          height: 128,
        }}
        src={source}
      />
    );
  }
  if (preview) {
    return (
      <video
        style={{
          height: 128,
        }}
        src={preview}
      />
    );
  }
  return (
    <div
      style={{
        height: 128,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spinner />
    </div>
  );
};

export default VideoPreview;
